export enum SchemeTabs {
  System = 'system-scheme',
  Internal = 'internal-scheme',
}
